module.exports = __webpack_public_path__ + "static/media/universeum_tmp-se.9e5c20f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/universeum_tmp-se.png
// module id = 108
// module chunks = 0